import React, { useState } from 'react'
import Select from 'react-select'
import { Icon } from 'antd'
import './CompetitionFilter.scss'
import { useTranslation } from 'react-i18next'

const CompetitionFilter = ({
  activeTab,
  competitions,
  selectedCompetition,
  onCompetitionChange,
  onSearch,
  fetching
}) => {
  const [isTyping, setIsTyping] = useState(false)

  const options = [
    ...(competitions && competitions.length > 0
      ? competitions.map(competition => ({
        value: competition.id,
        label: competition.title
      }))
      : [{ value: 'none', label: 'None' }])
  ]

  const handleChange = selectedOption => {
    if (selectedOption) {
      onCompetitionChange(selectedOption)
    } else {
      onSearch('')
    }
  }

  const handleInputChange = inputValue => {
    setIsTyping(inputValue.length > 0)
  }
  const { t } = useTranslation()
  const isQuest = activeTab === 'quest'

  return (
    <div className={`competition-filter ${isQuest ? 'quest-filter' : ''}`}>
      <div className="competition-filter__label">
        {isQuest ? (
          <><Icon type="compass" style={{ marginRight: 8, fontSize: '18px' }} /> {t('quest:choose_a_quest')}:</>
        ) : (
          `${t('v4:competition_filter')}:`
        )}
      </div>
      <div className="competition-filter__select">
        <Select
          value={selectedCompetition}
          onChange={handleChange}
          onInputChange={handleInputChange}
          options={options}
          placeholder={isQuest ? t('quest:search_or_select_a_quest') : t('v5:select_a_competition')}
          isLoading={fetching}
          isClearable={isTyping}
          isSearchable
          className="competition-select"
          classNamePrefix="competition-select"
        />
      </div>
    </div>
  )
}

export default CompetitionFilter
